export default __webpack_public_path__ + "static/media/footerImg3.1945085c.png";